module.exports = __webpack_public_path__ + "static/media/localiser-agent-icon.7ae8cac8.svg";